/** Timeline selection ids are "agent:<uuid>", but deep links
 *  (router.pendingItemId from navigate("episodes","episode",<uuid>) —
 *  bell dropdown, search drill-in) deliver the RAW uuid. Normalize so
 *  the timeline lookup matches instead of falling back to the first item. */
// @tested-by: tst_fe_chats_nav_001
export function normalizeEpisodeSelectionId(
  id: string | undefined,
): string | undefined {
  if (!id) return id;
  return id.startsWith("agent:") ? id : `agent:${id}`;
}

/** Selection to feed useListSelection: the store value when set, else a
 *  pending deep link (router.pendingItemId, raw uuid). Keeps the
 *  default-select-first effect from overwriting an in-flight deep link
 *  on a fresh module mount (both effects run in the same commit and the
 *  default branch still sees the empty store it captured at render). */
// @tested-by: tst_fe_chats_nav_002
export function effectiveSelectionId(
  storeId: string | undefined,
  pendingId: string | undefined,
): string | undefined {
  return storeId ?? normalizeEpisodeSelectionId(pendingId);
}

export function getEpisodeRouteSelection(
  entityType: string | undefined,
  entityId: string | undefined,
): string | undefined {
  if (entityType !== "episode" || !entityId) {
    return undefined;
  }
  return `agent:${entityId}`;
}

export function shouldSyncEpisodeSelectionFromRoute(
  routeSelection: string | undefined,
  storeSelection: string | undefined,
): boolean {
  return routeSelection !== undefined && routeSelection !== storeSelection;
}
